import { mountReact } from "../mountReact.jsx";
import WishlistGrid from "../components/WishlistGrid.jsx";

mountReact("#wishlist-react-root", WishlistGrid);
